import { useEffect } from "react";
import useReservations from "../../auth/Reservations";
import Login from "./Reservations/Login";
import MyReservations from "./Reservations/MyReservations";
import ReservationsLoading from "../Loaders/ReservationsLoading";
import { useRouter } from "next/router";
import { AuthLogin } from "../api";
import { toast } from "react-toastify";
import { useTranslation } from "../../context/TranslationContext";

const Reservations = ({ ssr, isAppWebView }) => {
  const router = useRouter();
  const { data, loading, checkLogin, setLoading } = useReservations();
  const { loginSuccess } = useTranslation();

  useEffect(() => {
    if (router.query.authKey || router.query.token) {
      AuthLogin(null, null, router.query.authKey, router.query.token)
        .then((response) => {
          if (response.data.error) {
            localStorage.removeItem("reservations_auth");
            toast.error(response.data.error);
          } else {
            localStorage.setItem("reservations_auth", response.data.token);
            toast.success(loginSuccess);
            checkLogin();
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } else {
      checkLogin();
    }
  }, []);

  return (
    <div className="bg-[#EDF6FB]  lg:h-[calc(100vh-96px)]">
      {loading ? (
        <ReservationsLoading className={"min-h-[calc(100vh-96px)]"} />
      ) : data && data.IsLogin != false ? (
        <MyReservations
          data={data}
          ssr={ssr}
          checkLogin={checkLogin}
          setLoading={setLoading}
          isAppWebView={isAppWebView}
        />
      ) : (
        <Login checkLogin={checkLogin} ssr={ssr} />
      )}
    </div>
  );
};

export default Reservations;
